export default __webpack_public_path__ + "static/media/mic_off_white_48dp.308efe03.svg";